export default __webpack_public_path__ + "assets/15.9fed5fc3.png";